import dictionary from './dictionary.json.js';
const config = {
    resource: 'next-insurance',
    dictionary,
};
export default config;
//# sourceMappingURL=config.js.map